import * as React from 'react';

import Page from 'components/page/Page';
import { Box, BoxPart } from 'components/box';

import AdminDashboardSection from '../../../admin/components/dashboard/admin-dashboard-section/AdminDashboardSection';

import { __t, applyTranslations } from 'utils/language';

import './misc-dashboard-page.scss';

applyTranslations(require('./misc-dashboard-page.i18n.json'));

const MiscDashboardPage = () => (
  <Page
    documentTitle={__t('misc_dashboard_page.title')}
  >
    <Box bordered>
      <BoxPart>
        <div className="misc-dashboard-page">
          <div>
            <AdminDashboardSection
              title={__t('misc_dashboard_page.zalando_brands')}
              items={[
                {
                  to: '/miscellaneous/add-brands',
                  name: __t('misc_dashboard_page.add_brand'),
                  icon: 'add'
                }
              ]}
            />
          </div>
        </div>
      </BoxPart>
    </Box>
  </Page>
);

export default MiscDashboardPage;
